import React from 'react'
import { useTranslation } from 'react-i18next'

export const Introduction: React.FC = () => {
  const { t } = useTranslation()

  return (
    <p className="mt-2 text-lg text-color-secondary">
      {t('eInvoiceOverview.title.introduction')}
    </p>
  )
}
